var url = "/apps/livesearch/supportFile/supportManageLiveSearch.php";


$(document).ready(function () {
  $("form[action='/search']").attr("autocomplete", "off");

  //   $('form[action="/search"]').each(function() {
  //     var liveSearchBox=$("<div>");
  //     liveSearchBox.addClass("livesearch");
  //     var ul=$("<ul>");
  //     ul.addClass("resultUlList");
  //     liveSearchBox.append(ul);

  //     var that=$(this).after(liveSearchBox);
  //   });


});

$(document).on('keyup', 'form[action="/search"] input[name="q"],form[action="/pages/search-results"] input[name="q"]', function () {
  var resultsList = $(this).closest('body').find(".ak_livesearch_panel ul.resultUlList");

  var position = $(this)[0].getBoundingClientRect();
  var topPosition = position.top;
  var resultsetWidth = position.width;
  var leftPosition = position.left;
  var leftPanel = parseFloat(leftPosition) + parseFloat(resultsetWidth);
  var rightPanel = position.right;
  var resultsetHeight = position.height;
  resultsetHeight = parseInt(resultsetHeight);
  resultsetWidth = parseInt(resultsetWidth) - 2;

  topPosition = parseInt(topPosition) + resultsetHeight;




  if (resultsetWidth <= 422) {
    resultsetWidth = 422;
  }
  var body = $("body")[0].getBoundingClientRect();
  var bodyTop = Math.abs(body.top);
  topPosition = topPosition + bodyTop;
  var footerBGColor = $footerBgColor;
  if (leftPosition >= 800) {

    var bodyRightPosition = body.right;
    var rightP = parseFloat(bodyRightPosition) - parseFloat(position.right);
    resultsList.css({
      'right': rightP + 'px',
      'top': topPosition + 'px',
      'width': resultsetWidth + 'px',
      'left': '',
      'border': '1px solid ' + footerBGColor
    });
  } else {
    resultsList.css({
      'left': leftPosition + 'px',
      'top': topPosition + 'px',
      'width': resultsetWidth + 'px',
      'right': '',
      'border': '1px solid ' + footerBGColor
    });
  }



  var term = $(this).val();
  var searchURL = "/search?type=product&q="+encodeURI(term);
  if (term == "") {
    resultsList.hide();
    return false;
  }
  if (term.length >= 1) {
    $.post(url, {
      "shopid": window.ak.shopid,
      "str": term,
      "action": "quickSearch"
    }, function (dataObject) {

      var data = $.parseJSON(dataObject);
      resultsList.empty();
      // If we have no results.
      if (data.status == "0") {
        // If we have results.
        resultsList.show();
        $.each(data.keyword, function (index, item) {
          var li = $("<li class='store-keyword'>");
          li.css('background-color', $bgColor);
          li.attr("data-str", item.title);
          li.attr("data-handle", item.handle);
          li.attr("data-product_type", item.type);
          li.attr("data-vendor", item.brand);

          var aMainTag = $('<a class="ak_main">');
          aMainTag.attr('href', ak.shop_url + "/products/" + item.handle);
          aMainTag.attr('target', '_blank');

          var div_row = $("<div class='ak_row clearfix'>");
          var div_col2 = $("<div class='ak_col_2'>");

          var imgLink = $("<img>");
          var imgUrl = imgURL(item.image, "50x50");
          imgLink.attr("src", imgUrl);

          div_col2.append(imgLink);
          div_row.append(div_col2);

          var div_col10 = $("<div class='ak_col_10'>");
          var aTag = $('<a class="ak_font_li">');
          if (resultsetWidth < 422) {
            div_col2.addClass('ak_mob_col_2');
            aTag.addClass('ak_mob_font_li');
          } else {
            div_col2.removeClass('ak_mob_col_2');
            aTag.removeClass('ak_mob_font_li');
          }
          aTag.css('color', $txtColor);
          aTag.attr('href', ak.shop_url + "/products/" + item.handle);
          aTag.attr('target', '_blank');


          if (data.show_price == 'yes') {
            aTag.html('<b>' + item.title + '</b>');
            //aTag.html('<b>' + item.title + '</b> <br>' + '$' + (parseFloat(item.price) / 100));
          } else {
            aTag.html('<b>' + item.title + '</b>');
          }
          var pForTitle = $("<p>");
          pForTitle.addClass("title");




          aTag.append(pForTitle);
          div_col10.append(aTag);
          div_row.append(div_col10);
          aMainTag.append(div_row);
          li.append(aMainTag);


          resultsList.append(li);
        });
        //         var hrTag= $("<hr class='ak-HrLine'>");
        //         resultsList.append(hrTag);
        resultsList.append('<li class="master-search" data-str=' + data.correct_word + ' style="background-color:' + $footerBgColor + ';"><span class="ak-lineheight-li"><a class="ak-footer-txt" href=' + searchURL + ' style="color:' + $footerTxtColor + ';">See all results of ' + data.correct_word + '</a></span></li>');
        if (resultsetWidth < 422) {
          $(".ak-footer-txt").addClass('ak-mob-footer-txt');
        } else {
          $(".ak-footer-txt").removeClass('ak-mob-footer-txt');
        }
      } else if (data.status == "2") {

        resultsList.show();
        var divHead = $("<div class='ak-matching-tab-head'>");
        divHead.html("<h4 '>Similar Keywords</h4>");
        resultsList.append(divHead);

        $.each(data.keyword, function (index, item) {
          var keywords = item;
          var searchURL = '/search?type=product&q=' + keywords;
          var aTag = $("<a>");
          aTag.attr("href", searchURL);
          var divTag = $("<div class='ak-matching-tab'>");
          divTag.html(keywords);
          aTag.append(divTag);
          resultsList.append(aTag);


        });

      } else {
        resultsList.show();
        var divHead = $("<div>");
        divHead.html("<center><h4>No results found</h4></center>");
        resultsList.append(divHead);
        resultsList.append('<div class="master-search" data-str=' + data.correct_word + ' style="background-color:' + $footerBgColor + ';"><span class="ak-lineheight-li" style="line-height: 40px;"><a class="ak-footer-txt" href=' + searchURL + ' style="color:' + $footerTxtColor + ';">See all results</a></span></div>');
        if (resultsetWidth < 422) {
          $(".ak-footer-txt").addClass('ak-mob-footer-txt');
        } else {
          $(".ak-footer-txt").removeClass('ak-mob-footer-txt');
        }
      }
    });

  } else {

  }
});


$(document).on("mouseenter", ".store-keyword", function () {
  $(this).css('background-color', $hoverBgColor);
  $(this).find('.ak_font_li').css('color', $hoverTxtColor);

});

$(document).on("mouseleave", ".store-keyword", function () {
  $(this).css('background-color', $bgColor);
  $(this).find('.ak_font_li').css('color', $txtColor);
});




function imgURL(src, size) {
  // remove any current image size then add the new image size
  return src
  .replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, '.')
  .replace(/\.jpg|\.png|\.gif|\.jpeg/g, function (match) {
    return '_' + size + match;
  });
}
;

$(document).on('click', '.master-search', function () {
  debugger;
  var str = $(this).attr("data-str");
  $.post(url, {
    "shopid": window.ak.shopid,
    "str": str,
    "action": "quickSearch",
    "flag": 1 //master search
  }, function (dataObject) {
    var data = $.parseJSON(dataObject);
  });
});

$(document).on('click', '.store-keyword', function () {
  debugger;

  var str = $(this).attr("data-str");
  var handle = $(this).attr("data-handle");
  var product_type = $(this).attr("data-product_type");
  var vendor = $(this).attr("data-vendor");

  $.post(url, {
    "shopid": window.ak.shopid,
    "str": str,
    "action": "storeKeyword",
    "handle": handle,
    "product_type": product_type,
    "vendor": vendor,
    "lat": ak.lat,
    "long": ak.long

  }, function (dataObject) {
    var data = $.parseJSON(dataObject);
  });
});



var resultsSelected = false;

$(document).on("mouseenter", ".resultUlList", function () {
  resultsSelected = true;
});


$(document).on("mouseleave", ".resultUlList", function () {
  resultsSelected = false;
});

$(document).on('blur', 'form[action="/search"] input[name="q"],form[action="/pages/search-results"] input[name="q"]', function () {
  var resultsList = $(this).closest('body').find(".ak_livesearch_panel ul.resultUlList");
  if (!resultsSelected) {  //if you click on anything other than the results
    resultsList.hide();  //hide the results
  }
});

$(document).on('focus', 'form[action="/search"] input[name="q"],form[action="/pages/search-results"] input[name="q"]', function () {
  $(".ak_livesearch_panel ul.resultUlList").hide();
  var resultsList = $(this).closest('body').find(".ak_livesearch_panel ul.resultUlList");
  var position = $(this)[0].getBoundingClientRect();
  var topPosition = position.top;
  var resultsetWidth = position.width;
  var leftPosition = position.left;
  var leftPanel = parseFloat(leftPosition) + parseFloat(resultsetWidth);
  var rightPanel = position.right;
  var resultsetHeight = position.height;
  resultsetHeight = parseInt(resultsetHeight);
  resultsetWidth = parseInt(resultsetWidth) - 2;
  topPosition = parseInt(topPosition) + resultsetHeight;
  if (resultsetWidth <= 422) {
    resultsetWidth = 422;
  }
  var body = $("body")[0].getBoundingClientRect();
  var bodyTop = Math.abs(body.top);
  topPosition = topPosition + bodyTop;
  var footerBGColor = $footerBgColor;
  if (leftPosition >= 800) {
    var body = $("body")[0].getBoundingClientRect();
    var bodyRightPosition = body.right;
    var rightP = parseFloat(bodyRightPosition) - parseFloat(position.right);

    resultsList.css({
      'right': rightP + 'px',
      'top': topPosition + 'px',
      'width': resultsetWidth + 'px',
      'left': '',
      'border': '1px solid ' + footerBGColor

    });
  } else {
    resultsList.css({
      'left': leftPosition + 'px',
      'top': topPosition + 'px',
      'width': resultsetWidth + 'px',
      'right': '',
      'border': '1px solid ' + footerBGColor
    });
  }
  var term = $(this).val();
  if (term == "") {
    resultsList.hide();
  } else {
    resultsList.show();
  }
});